import {Type} from '@mintdata/mint-kit/api/types/Type';
import {ErrorOrEmpty} from '@mintdata/mint-kit/api/types/Value';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {AByte} from '@mintdata/mint-kit/api/values/AByte';
import {ACurrency} from '@mintdata/mint-kit/api/values/ACurrency';
import {ADate} from '@mintdata/mint-kit/api/values/ADate';
import {ADateTime} from '@mintdata/mint-kit/api/values/ADateTime';
import {AInteger} from '@mintdata/mint-kit/api/values/AInteger';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {ATime} from '@mintdata/mint-kit/api/values/ATime';
import {BaseCoercionUtil} from '@mintdata/mint-kit/impl/coercionUtils/BaseCoercionUtil';
import {ExcelDateTimeUtil} from '@mintdata/mint-kit/impl/coercionUtils/ExcelDateTimeUtil';

export class CurrencyCoercionUtil extends BaseCoercionUtil
{
    constructor()
    {
        super(Type.Currency);
    }

    public toBoolean(from:ACurrency):ABoolean | ErrorOrEmpty
    {
        return new ABoolean(from.value !== 0);
    }

    public toByte(from:ACurrency):AByte | ErrorOrEmpty
    {
        return from;
    }

    public toCurrency(from:ACurrency):ACurrency | ErrorOrEmpty
    {
        return new ACurrency(from.value);
    }

    public toInteger(from:ACurrency):AInteger | ErrorOrEmpty
    {
        return new AInteger(Math.round(from.value));
    }

    public toNumber(from:ACurrency):ANumber | ErrorOrEmpty
    {
        return new ANumber(from.value);
    }

    public toDate(from:ACurrency):ADate | ErrorOrEmpty
    {
        return ExcelDateTimeUtil.excelDateToADate(from.value);
    }

    public toDateTime(from:ACurrency):ADateTime | ErrorOrEmpty
    {
        return ExcelDateTimeUtil.excelDateToADateTime(from.value);
    }

    public toTime(from:ACurrency):ATime | ErrorOrEmpty
    {
        return ExcelDateTimeUtil.excelTimeToATime(from.value);
    }

    public toString(from:ACurrency):AString | ErrorOrEmpty
    {
        throw new Error('Method not implemented.');
    }
}
